module.exports = "/static/images/BCT-logo-full.png";